"use client"

import { FilterItem } from "./FilterItem"
import { FilterWrapper } from "./FilterWrapper"
import { useFilters } from "./useFilters"

interface Props {
  options: {
    title: string
    value: string
  }[]
}

const id = "orderBy"

export const OrderByFilter: React.FC<Props> = ({ options }) => {
  /* TODO should add default */
  const { toggleFilter, getActiveFilters } = useFilters()

  const selectedIds = getActiveFilters(id)?.[0]

  const onSelectItem = (filterId: string) => {
    toggleFilter({ params: [{ key: id, values: [filterId] }] })
  }

  const buttonText = options.find(option => option.value === selectedIds)?.title || options[0]?.title

  return (
    <FilterWrapper
      id={id}
      onRemoveAll={() => {}}
      filterActive={selectedIds?.length > 0}
      buttonText={buttonText}
      hasSearch={false}>
      <div className="flex w-full mt-3">
        <div className="flex flex-col gap-1 w-full">
          {options?.map(option => {
            return (
              <FilterItem
                key={option.value}
                name={option.title}
                selected={selectedIds?.includes(option.value)}
                onClick={() => onSelectItem(option.value)}
              />
            )
          })}
        </div>
      </div>
    </FilterWrapper>
  )
}
